<template>
  <anomalie />
</template>

<script>
import Anomalie from '@/components/ask/pages/contratti-vendita/Anomalie.vue'

export default {
  name: 'AnomalieContrattiVendita',

  components:{
    Anomalie
  },

  data(){
    return {
    
    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods:{

  },
}
</script>

<style>

</style>
